export default __webpack_public_path__ + "static/media/blinkingMan.30786e79.webm";